export default __webpack_public_path__ + "static/media/kimiya-home-image.05574444.jpg";